import { render } from "./IrrigSC.vue?vue&type=template&id=163cecd8&scoped=true"
import script from "./IrrigSC.vue?vue&type=script&lang=js"
export * from "./IrrigSC.vue?vue&type=script&lang=js"

import "./IrrigSC.vue?vue&type=style&index=0&id=163cecd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163cecd8"]])

export default __exports__